// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

type Props = {
  general: boolean,
};

export const ErrorWrapper = styled<any, Theme, Props>('div')`
  background-color: ${props => props.theme.form.error.backgroundColor};
  border-radius: ${props => (props.general ? props.theme.form.error.borderRadiusGeneral
    : props.theme.form.error.borderRadius)};
  font-size: 0.875rem;
  padding: 0.125rem 1rem 0.25rem;
`;

export const ErrorMessage = styled<any, Theme>('span')`
  color: ${props => props.theme.form.error.color};
`;

export default null;
